import { PLACEMARK_DEFAULT_ICON } from '../../utils/placemarkIcons/placemarkIconRenderer';
export const DEFAULT_PLACEMARK_COLOR = '#DC143C';
export { PLACEMARK_DEFAULT_ICON };
